module.exports = __webpack_public_path__ + "media/images/warnings/warning_3-94cf99617b5fff0d0be1e1551ebace13.svg";